document.addEventListener('DOMContentLoaded', function() {
  function initializeSwiper() {
    var swiperContainers = document.querySelectorAll('.swiper-container');
    swiperContainers.forEach(function(container) {
      if (!container.classList.contains('swiper-initialized')) {
        new Swiper(container, {
          slidesPerView: 1,
          spaceBetween: 10,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
        container.classList.add('swiper-initialized');
      }
    });
  }

  // Inicializa o Swiper ao carregar a página e quando o DOM é atualizado
  initializeSwiper();

  // Inicializa o Swiper ao redimensionar a tela
  window.addEventListener('resize', initializeSwiper);
});

// Shopify events for dynamic sections
document.addEventListener('shopify:section:load', function() {
  initializeSwiper();
});
